import React from 'react';

import { Switch, Form, Divider } from 'antd';

import { IUserPermission } from '@entities/user-permission';

interface IPermissionsProps {
    userPermissions: Array<IUserPermission>;
    isViewOnly: boolean;
    onChangeUserPermissions: (e: Array<IUserPermission>) => void;
}

const UserPermissions = (props: IPermissionsProps) => {
    const { userPermissions, isViewOnly, onChangeUserPermissions } = props;

    return (
        <div>
            <Form.Item wrapperCol={{ span: 24 }} style={{ marginBottom: 5 }}>
                <Divider style={{ marginTop: 0, marginBottom: 0 }} titlePlacement='left'>
                    Разрешения
                </Divider>
            </Form.Item>

            {userPermissions.map((p) => {
                if (p.permissionCode < 0) {
                    return (
                        <Form.Item key={p.permissionCode} wrapperCol={{ span: 24 }} style={{ marginBottom: 5 }}>
                            <Divider style={{ marginBottom: 0 }}>{p.name}</Divider>
                        </Form.Item>
                    );
                }

                return (
                    <Form.Item
                        labelAlign='left'
                        key={p.permissionCode}
                        label={p.name || p.permissionCode}
                        labelCol={{ span: 22 }}
                        wrapperCol={{ span: 2 }}
                        style={{ marginBottom: 0 }}
                    >
                        <Switch
                            size='small'
                            disabled={isViewOnly}
                            defaultChecked={p.isActive}
                            onChange={(value) => {
                                const entities = [...userPermissions];

                                const entity = entities.find((e) => e.permissionCode === p.permissionCode);

                                if (entity) {
                                    entity.isActive = value;

                                    onChangeUserPermissions([...entities]);
                                }
                            }}
                        />
                    </Form.Item>
                );
            })}
        </div>
    );
};

export default UserPermissions;
